import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getFaqList = (payload, callback) =>
  req.list(
    c.GET_FAQ_LIST,
    '/api/v1/administrators/faq_menu',
    payload,
    callback
  );

export const showFaq = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_FAQ,
    `/api/v1/administrators/faq_menu/${id}`,
    payload,
    callback
  );

export const createFaq = (payload, callback) =>
  req.create(
    c.CREATE_FAQ,
    '/api/v1/administrators/faq_menu',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateFaq = (id, payload, callback) =>
  req.update(
    c.UPDATE_FAQ,
    `/api/v1/administrators/faq_menu/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeFaq = (id, payload, callback) =>
  req.remove(
    c.REMOVE_FAQ,
    `/api/v1/administrators/faq_menu/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );
